import addressingRules from "./addressing-rules";
import cohabitableBuses from "./cohabitable-buses";
import platformCapabilities from "./platformcapabilities";
import sku from "./sku";

const externalConfiguration = {
    addressingRules,
    cohabitableBuses,
    platformCapabilities,
    sku,
};


export default externalConfiguration;
